import { initializeControls } from '@atlassian/browser-storage-controls/cookie-controls';
// eslint-disable-next-line no-restricted-imports
import { isFedRamp, isIsolatedCloud } from '@atlassian/atl-context';
import type { BscInitializationResult } from '@atlassian/browser-storage-controls/types';

/**
 * Initializes browser storage controls for cookies and optionally web storage
 * (localStorage/sessionStorage) when confluence_browser_storage_controls feature gate is enabled.
 *
 * This should be called once during app bootstrap, before any cookie or storage operations.
 * Both the Cookies class and storage-manager depend on this being initialized.
 */
export const initializeBrowserStorageControls = ({
	userId,
	cloudId,
}: {
	userId?: string;
	cloudId?: string;
}): Promise<BscInitializationResult | undefined> => {
	// We want to store cookies locally when in Isolated Cloud (IC) because like FedRAMP,
	// Consent Hub is not hydrated in IC.
	// (note: this property is ignored and forced to "true" when a FedRAMP perimeter is passed in)
	const shouldUseLocalConsentMode = isIsolatedCloud();

	return initializeControls({
		product: 'Confluence',
		webStorageEnabled: true,
		allowUncategorizedItemsInWebStorageOverrides: false,
		perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial',
		localConsentMode: shouldUseLocalConsentMode,
		userId,
		cloudId,
	});
};
